import React from 'react';

const Logo = (props) => {
  return (
    <img
      alt="Logo"
      src="/static/icons/logo.svg"
      {...props}
    />
  );
};

export default Logo;
